import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/myorders.css";

function MyOrders() {

    const userId = localStorage.getItem("user_id");

    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [products, setProducts] = useState([]);

    useEffect(() => {

        if (userId) {
            loadOrders();
        }

    }, []);

    const loadOrders = () => {

        axios
            .get(`${API_URL}/my-orders/${userId}`)
            .then((res) => {
                setOrders(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

    };

    const viewDetails = (orderId) => {

        axios
            .get(`${API_URL}/order-details/${orderId}`)
            .then((res) => {

                setProducts(res.data);
                setSelectedOrder(orderId);

            })
            .catch((err) => {

                console.log(err);

            });

    };

    return (

        <div className="myorders-page">

            <div className="myorders-container">

                <h1>My Orders</h1>

                {

                    orders.length === 0 ?

                        <p>No Orders Found.</p>

                        :

                        orders.map((order) => (

                            <div
                                className="order-card"
                                key={order.id}
                            >

                                <div className="order-header">

                                    <h2>
                                        Order #{order.id}
                                    </h2>

                                    <span className={`status ${order.order_status.toLowerCase()}`}>
                                        {order.order_status}
                                    </span>

                                </div>

                                <p>
                                    <strong>Date:</strong>{" "}
                                    {new Date(order.created_at).toLocaleDateString()}
                                </p>

                                <p>
                                    <strong>Total:</strong> ₹{order.total}
                                </p>

                                <p>
                                    <strong>Payment:</strong> {order.payment_status}
                                </p>

                                <p>
                                    <strong>Delivery Address:</strong><br />

                                    {order.full_name}<br />
                                    {order.address}<br />
                                    {order.city}, {order.state}<br />
                                    {order.zip_code}

                                </p>

                                <button
                                    className="view-btn"
                                    onClick={() => viewDetails(order.id)}
                                >
                                    View Details
                                </button>

                                {

                                    selectedOrder === order.id && (

                                        <div className="products-list">

                                            <h3>Purchased Products</h3>

                                            {

                                                products.map((item) => (

                                                    <div
                                                        className="product-item"
                                                        key={item.id}
                                                    >

                                                        <img
                                                            src={`http://localhost:5000${item.image}`}
                                                            alt={item.product_name}
                                                        />

                                                        <div>

                                                            <h4>
                                                                {item.product_name}
                                                            </h4>

                                                            <p>
                                                                Quantity : {item.quantity}
                                                            </p>

                                                            <p>
                                                                Price : ₹{item.price}
                                                            </p>

                                                        </div>

                                                    </div>

                                                ))

                                            }

                                        </div>

                                    )

                                }

                            </div>

                        ))

                }

            </div>

        </div>

    );

}

export default MyOrders;